export default __webpack_public_path__ + "static/media/No.3-0.dac25a12.jpg";